import React, { useContext } from 'react';
import { Col, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import moment from "moment";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from 'react-bootstrap-table2-paginator';
import { useHistory } from "react-router-dom"
import useMoves from '../Hooks/useMoves';
import { AssignmentType } from '../../../api/Inventory/Entities/InventoryEntities';
import { MoveStatus, MoveTypes } from '../../../api/Inventory/Entities/InventoryMovementEntities';
import Loader from '../../../components/Common/Loader';
import { Tooltip } from '../../../components/Utils/Tooltips';
import { Add, Check, Export, More } from '../../../components/Icons/Icons';
import Card from '../../../components/Cards/Card';
import { WithAuth } from '../../../components/Authorization/WithAuth';

export default function PharmacyOperationsPage() {
    const { t } = useTranslation();
    const history = useHistory();
    const [pagedMoves, isLoading, navigation] = useMoves({
        pageSize: 10,
        pageNumber: 1,
        sortColumn: 'createat',
        sortOrder: 'desc',
        includedTypes: `${MoveTypes.PharmacyDispense.Name},${MoveTypes.PharmacyDispenseRequest.Name}`,
        assignmentTypes: AssignmentType.General.Name,
        assignId: null
    });

    function handleTableChange(type, { page, sizePerPage, sortField, sortOrder }) {
        navigation.ToPage({
            page
        })
    }

    function handleDispenseRequest() {
        history.push("/admin/inventory/pharmacy/request")
    }
    function handleDispense() {
        history.push("/admin/inventory/pharmacy/dispense")
    }

    function handleDispenseConfirm(dispenseId) {
        history.push(`/admin/inventory/pharmacy/${dispenseId}/confirm`)
    }
    function handleDispenseDeliver(dispenseId) {
        history.push(`/admin/inventory/dispense/${dispenseId}/deliver`)
    }

    function handleShowMoveDetail(dispenseId) {
        history.push(`/admin/inventory/pharmacy/${dispenseId}/detail`)
    }

    const columns = [
        {
            dataField: 'user.fullName', text: t('commons.name'), headerStyle: { width: '15rem' }
        },
        {
            text: t('commons.date'), headerStyle: { width: '6rem' }
            , formatter: function (_cell, move, rowIndex) {
                return moment(move.createAt).format("DD/MM/YYYY HH:mm");
            }
        },
        {
            dataField: 'status', text: t('commons.state'), headerStyle: { width: '7rem' }
            , formatter: (cell, row) => t(`inventory.movements.moveState.${cell}`)
        },
        {
            dataField: 'view',
            text: "",
            isDummyField: true,
            headerClasses: 'header-actions',
            classes: 'row-actions',
            formatter: function (_cell, row, rowIndex) {
                return (
                    <div key={rowIndex}>
                        {row.status == MoveStatus.Pending.Name.toLowerCase() &&
                            <WithAuth requiredPermission={["GeneralInventory.Confirm"]}>
                                <button type="button" className="btn-table-actions" onClick={() => { handleDispenseConfirm(row.id) }}>
                                    <Tooltip tooltip={t('inventory.dispense.confirmRequest')} id={"tooltipedit-" + row.Id}>
                                        <span aria-hidden="true"><Check /></span>
                                    </Tooltip>
                                </button>
                            </WithAuth>
                        }
                        {row.status == MoveStatus.Confirmed.Name.toLowerCase() &&
                            <WithAuth requiredPermission={["GeneralInventory.Deliver"]}>
                                <button type="button" className="btn-table-actions" onClick={() => { handleDispenseDeliver(row.id) }}>
                                    <Tooltip tooltip={t('inventory.dispense.deliver')} id={"tooltipedit-" + row.Id}>
                                        <span aria-hidden="true"><Export /></span>
                                    </Tooltip>
                                </button>
                            </WithAuth>
                        }
                        <button type="button" className="btn-table-actions" onClick={() => { handleShowMoveDetail(row.id) }}>
                            <Tooltip tooltip={t('commons.viewDetails')} id={"tooltipedit-" + row.Id}>
                                <span aria-hidden="true"><More /></span>
                            </Tooltip>
                        </button>
                    </div>
                )
            }
        }
    ]

    return (<>
        <Card
            header={<div>
                <WithAuth requiredPermission={["GeneralInventory.Create"]}>
                    <button type="button" onClick={() => handleDispense(0)} className="btn btn-primary">
                        <Tooltip tooltip={t('inventory.dispense.generateDispense')}>
                            <span aria-hidden="true"> {t('inventory.dispense.dispense')}  <Add /></span>
                        </Tooltip>
                    </button>
                </WithAuth>
                <WithAuth requiredPermission={["GeneralInventory.Request"]}>
                    <button type="button" onClick={() => handleDispenseRequest(0)} className="btn btn-primary" style={{ marginLeft: '1rem' }}>
                        <Tooltip tooltip={t('inventory.dispense.createRequest')}>
                            <span aria-hidden="true"> {t('inventory.dispense.request')} <Add /></span>
                        </Tooltip>
                    </button>
                </WithAuth>
            </div >}
            content={<Loader isLoading={isLoading} >
                <Row>
                    <Col sm={12}>
                        <BootstrapTable
                            bordered={false}
                            hover
                            remote
                            condensed
                            keyField='id'
                            classes="table-spaced table-spaced-small"
                            wrapperClasses="table-responsive"
                            columns={columns}
                            data={pagedMoves.Values}
                            loading={isLoading}
                            noDataIndication={() => <>{t("commons.noData")}</>}
                            pagination={paginationFactory({
                                page: pagedMoves.PageNumber,
                                sizePerPage: pagedMoves.PageSize,
                                totalSize: pagedMoves.TotalCount,
                                hideSizePerPage: true
                            })}
                            onTableChange={handleTableChange}
                        />
                    </Col>
                </Row>
            </Loader >}
        />
    </>)
}